import {Int, positive, Schema} from 'effect/Schema';

export const CurrencyId = Int.pipe(positive()) as unknown as Schema<CurrencyId>;
export type CurrencyId = import('../../src/Currency/CurrencyId').CurrencyId;
